"use client";
import { ImageType } from "@/types/app.type";
import { CSSProperties, lazy } from "react";
import dynamic from 'next/dynamic';
import { useResponsive } from "@/client/hooks/useResponsive";

const Video = dynamic(()=> import("@/components/Video/Video"), { ssr: false });
const ImageWrapper = dynamic(()=> import("@/components/ImageWrapper"), { ssr: false });

export interface CardVideoProps {
	/**
	 * The data-test-id of the CardVideo.
	 * @type string
	 * @optional
	 */
	"data-test-id"?: string;
	/**
	 * The url of the CardVideo.
	 * @type string
	 * @required
	 */
	url: string;
	mobileVideo?: any;
	/**
	 * The fallback source of the CardVideo.
	 * @type ImageType
	 * @required
	 */
	fallback: ImageType;
	/**
	 * Enable animation triggered whe the element is visible.
	 * @type boolean
	 * @optional
	 */
	animated?: boolean;
	/**
	 * The animation type triggered whe the element is visible. Default is fadeIn
	 * @type string
	 * @optional
	 */
	animation?: string;
	className?: string;
	minHeight?: string;
	style?: CSSProperties;
	playButtonPosition?: 'none' | 'center' | 'bottom-left' | 'top-right';
	pauseable: boolean;
	autoPlay: boolean;
	eventName?: string; 
	showCustomPlayButton?: boolean;
	thumbnailOnly?: boolean;
	image?: ImageType;
}

export function CardVideo({ minHeight, playButtonPosition, ...props }: CardVideoProps) {
  const { isMd, isSm } = useResponsive();
  return (
		<Video
			className={props.className}
			style={props?.style || {}}
			data-test-id={props["data-test-id"]}
			minHeight={minHeight || "100px"}
			width={props?.style?.width as string}
			height={props?.style?.height as string}
			videoUrl={isMd ? props.url : props?.mobileVideo}
			mobileVideo={props?.mobileVideo}
			playButtonPosition={playButtonPosition}
			loop
			muted
			// playsinline
			pauseable={props.pauseable || false}
			autoPlay={props.autoPlay}
			eventName={props?.eventName}
			showCustomPlayButton={props?.showCustomPlayButton || false}
			thumbnailOnly={props?.thumbnailOnly || false}
			fallback={
				<ImageWrapper
					src={props?.fallback?.src}
					alt="card-image"
					placeholder="blur"
					blurDataURL={props?.fallback?.src}
					width={props?.fallback?.width || 50}
					height={props?.fallback?.height || 50}
					priority
					// loading="lazy"
					loader={({ src }) => src}
					style={props?.style}
					className="!h-full object-cover max-w-none"
				/>
			}
			posterImage={props?.image?.src}
            // posterImage={
            //     <ImageWrapper
            //         src={props?.image?.src}
            //         alt="card-image"
            //         placeholder="blur"
            //         blurDataURL={props?.image?.src}
            //         width={props?.image?.width || 50}
            //         height={props?.image?.height || 50}
            //         priority
            //         loader={({ src }) => src}
            //         style={props?.style}
            //         className="poster-image !h-full object-cover max-w-none"
            //     />
            // }
		/>
		
	);
}
